<template>
  <div class="full pt-3 pt-lg-5 pb-5 px-3">
    <div class="wraper-dtr-acc mt-lg-5" v-if="doctor">
      <div class="d-flex mb-3 flex-wrap justify-content-center">
        <div
          class="me-3"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="doctor && (!doctor.user || !doctor.user.avatar)"
          >
            <g clip-path="url(#clip0_14074_11748)">
              <circle
                cx="19.9856"
                cy="19.9856"
                r="19.9856"
                fill="#476DD6"
              />
              <path
                d="M19.9848 8.32715C15.1739 8.32715 11.2627 12.2589 11.2627 17.0952C11.2627 21.8391 14.9535 25.6786 19.7644 25.8447C19.9113 25.8262 20.0582 25.8262 20.1684 25.8447C20.2051 25.8447 20.2235 25.8447 20.2602 25.8447C20.2786 25.8447 20.2786 25.8447 20.2969 25.8447C24.9977 25.6786 28.6885 21.8391 28.7068 17.0952C28.7068 12.2589 24.7957 8.32715 19.9848 8.32715Z"
                fill="white"
              />
              <path
                d="M29.3146 30.7547C24.1916 27.3213 15.8367 27.3213 10.6769 30.7547C8.34493 32.3237 7.05957 34.4465 7.05957 36.717C7.05957 38.9874 8.34493 41.0917 10.6586 42.6423C13.2293 44.3774 16.6079 45.245 19.9866 45.245C23.3653 45.245 26.7439 44.3774 29.3146 42.6423C31.6283 41.0733 32.9136 38.969 32.9136 36.68C32.8953 34.4096 31.6283 32.3053 29.3146 30.7547Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_14074_11748">
                <rect
                  width="40"
                  height="40"
                  rx="19.9856"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
          <img
            :src="getImageUrl(doctor.user.avatar)"
            alt=""
            class="avatar"
            v-if="doctor && doctor.user && doctor.user.avatar"
          >
        </div>
        <div>
          <p
            class="fs-24 fw-500 mb-3"
          >
            {{doctor.name}}
          </p>
          <div class="d-flex align-items-center mb-3 flex-wrap">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-2"
            >
              <path
                d="M5.33387 14.6667H10.6672C13.3472 14.6667 13.8272 13.5933 13.9672 12.2867L14.4672 6.95333C14.6472 5.32667 14.1805 4 11.3339 4H4.6672C1.82054 4 1.35387 5.32667 1.53387 6.95333L2.03387 12.2867C2.17387 13.5933 2.65387 14.6667 5.33387 14.6667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33398 4.00004V3.46671C5.33398 2.28671 5.33398 1.33337 7.46732 1.33337H8.53398C10.6673 1.33337 10.6673 2.28671 10.6673 3.46671V4.00004"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.33268 8.66667V9.33333C9.33268 9.34 9.33268 9.34 9.33268 9.34667C9.33268 10.0733 9.32602 10.6667 7.99935 10.6667C6.67935 10.6667 6.66602 10.08 6.66602 9.35333V8.66667C6.66602 8 6.66602 8 7.33268 8H8.66602C9.33268 8 9.33268 8 9.33268 8.66667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.434 7.33337C12.894 8.45337 11.134 9.12004 9.33398 9.34671"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.74609 7.51331C3.24609 8.53997 4.93943 9.15997 6.66609 9.3533"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span class="fs-12">
              {{doctor.chuc_vu}}
            </span>
          </div>
          <div class="d-flex align-items-center mb-3 flex-wrap">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-2"
            >
              <path
                d="M7.99992 8.95334C9.14867 8.95334 10.0799 8.02209 10.0799 6.87334C10.0799 5.72458 9.14867 4.79333 7.99992 4.79333C6.85117 4.79333 5.91992 5.72458 5.91992 6.87334C5.91992 8.02209 6.85117 8.95334 7.99992 8.95334Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
              <path
                d="M2.41379 5.66004C3.72712 -0.113291 12.2805 -0.106624 13.5871 5.66671C14.3538 9.05338 12.2471 11.92 10.4005 13.6934C9.06046 14.9867 6.94046 14.9867 5.59379 13.6934C3.75379 11.92 1.64712 9.04671 2.41379 5.66004Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
            </svg>

            <span class="fs-12">
              {{doctor.address}}
            </span>
          </div>
          <div class="d-flex align-items-center mb-3 flex-wrap">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-2"
            >
              <path
                d="M12.6673 5.33337C12.196 5.33219 11.7394 5.49794 11.3786 5.80123C11.0178 6.10453 10.776 6.52577 10.6962 6.99031C10.6163 7.45484 10.7035 7.93265 10.9422 8.33904C11.181 8.74544 11.556 9.05416 12.0007 9.21049V10.3334C12.0007 11.129 11.6846 11.8921 11.122 12.4547C10.5594 13.0173 9.7963 13.3334 9.00065 13.3334C8.205 13.3334 7.44194 13.0173 6.87933 12.4547C6.31672 11.8921 6.00065 11.129 6.00065 10.3334V9.93982C6.93173 9.78184 7.77697 9.29975 8.38695 8.57879C8.99694 7.85783 9.33238 6.94443 9.33398 6.00004V2.00004C9.33398 1.82323 9.26375 1.65366 9.13872 1.52864C9.0137 1.40361 8.84413 1.33337 8.66732 1.33337H7.33398C7.15717 1.33337 6.9876 1.40361 6.86258 1.52864C6.73756 1.65366 6.66732 1.82323 6.66732 2.00004C6.66732 2.17685 6.73756 2.34642 6.86258 2.47145C6.9876 2.59647 7.15717 2.66671 7.33398 2.66671H8.00065V6.00004C8.00065 6.70728 7.7197 7.38556 7.2196 7.88566C6.71951 8.38576 6.04123 8.66671 5.33398 8.66671C4.62674 8.66671 3.94846 8.38576 3.44837 7.88566C2.94827 7.38556 2.66732 6.70728 2.66732 6.00004V2.66671H3.33398C3.5108 2.66671 3.68036 2.59647 3.80539 2.47145C3.93041 2.34642 4.00065 2.17685 4.00065 2.00004C4.00065 1.82323 3.93041 1.65366 3.80539 1.52864C3.68036 1.40361 3.5108 1.33337 3.33398 1.33337H2.00065C1.82384 1.33337 1.65427 1.40361 1.52925 1.52864C1.40422 1.65366 1.33398 1.82323 1.33398 2.00004V6.00004C1.33559 6.94443 1.67103 7.85783 2.28102 8.57879C2.891 9.29975 3.73624 9.78184 4.66732 9.93982V10.3334C4.66732 11.4826 5.12386 12.5848 5.93652 13.3975C6.74918 14.2102 7.85138 14.6667 9.00065 14.6667C10.1499 14.6667 11.2521 14.2102 12.0648 13.3975C12.8774 12.5848 13.334 11.4826 13.334 10.3334V9.21053C13.7787 9.05419 14.1536 8.74546 14.3924 8.33907C14.6312 7.93268 14.7183 7.45487 14.6385 6.99033C14.5586 6.5258 14.3168 6.10455 13.956 5.80125C13.5952 5.49796 13.1387 5.3322 12.6673 5.33337ZM12.6673 8.00004C12.5355 8.00004 12.4066 7.96094 12.2969 7.88769C12.1873 7.81443 12.1019 7.71031 12.0514 7.5885C12.0009 7.46668 11.9877 7.33263 12.0135 7.20331C12.0392 7.07399 12.1027 6.9552 12.1959 6.86197C12.2891 6.76873 12.4079 6.70524 12.5373 6.67952C12.6666 6.65379 12.8006 6.667 12.9224 6.71745C13.0443 6.76791 13.1484 6.85336 13.2216 6.96299C13.2949 7.07263 13.334 7.20152 13.334 7.33337C13.3338 7.51011 13.2634 7.67955 13.1385 7.80453C13.0135 7.9295 12.8441 7.99981 12.6673 8.00004Z"
                fill="#476DD6"
              />
            </svg>

            <span class="fs-12 txt-pri">
              {{doctor.majors}}
            </span>
          </div>
        </div>
      </div>
      <div class="box-content mt-5">
        <p class="text-center fs-16 fw-500 mw-325 m-auto mb-2" v-if="doctor"><span v-if="!doctor.type">Bác sĩ </span>{{doctor.name}} đã đồng ý tham gia theo dõi Hồ Sơ Sức Khỏe của bạn</p>
        <p class="text-center fs-16 mw-325 m-auto mb-3">Tải HODO để kết nối và trao đổi với bác sĩ</p>
          <div class="d-flex align-items-center justify-content-center">
            <div class="border-end pe-3 border-dark">
              <img
                src="../../../public/images/common/hodo_qr.svg"
                alt=""
              >
            </div>
            <div class="ps-3">
              <img
                src="../../../public/images/home/appstoredowload.png"
                class="dowload-img c-pointer mb-3"
                alt=""
                @click="goToPStore('i')"
              >
              <img
                src="../../../public/images/home/ggdowload.png"
                class="dowload-img c-pointer"
                alt=""
                @click="goToPStore('a')"
              >
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'DoctorAccept',
  data () {
    return {
      doctor: {}
    }
  },
  mounted () {
    const self = this
    self.getDoctorDetail()
  },
  methods: {
    async getDoctorDetail () {
      const self = this
      await self.$rf.getRequest('AuthRequest').getDoctorDetail(self.$route.params.id, false).then((r) => {
        self.doctor = r.data
      }).catch((e) => {
        window.$toast.open({
          message: 'Bạn không có quyền xem thông tin này hoặc đã có lỗi xảy ra',
          type: 'error'
        })
      })
    },
    getImageUrl (avatar) {
      return appUtils.getDocumentURL(avatar)
    },
    goToPStore (os) {
      if (os === 'a') {
        window.open(process.env.VUE_APP_GOOGLE_PLAY)
      }
      if (os === 'i') {
        window.open(process.env.VUE_APP_APPLE_STORE)
      }
    }
  }
}
</script>

<style scoped>
.full {
  background-color: #f7f7f9;
  height: calc(100vh - 75px);
}
.wraper-dtr-acc {
  width: 100%;
  max-width: 621px;
  padding: 32px 0;
  margin: 0 auto;
  border-radius: 32px;
}
.avatar {
  width: 169px;
  height: 169px;
  border-radius: 29px;
  margin-right: 16px;
}
.box-content {
  width: 100%;
  max-width: 621px;
  padding: 16px 0;
  margin: 0 auto;
  background: #fcfcfd;
  box-shadow: 0px 10px 32px rgba(15, 15, 15, 0.05);
  border-radius: 32px;
}
.mw-325 {
  max-width: 325px;
}
.dowload-img {
  max-width: 135px;
  margin-bottom: 5px;
  display: block;
  width: auto;
  height: auto;
}
</style>
